module.exports = "<p>\r\n  statuser works!\r\n</p>\r\n"